(function () {
  'use strict';

  var TEXT_DEFAULT = 'AÑADIR';
  var TEXT_ADDED = '✓ AÑADIDO';
  var TEXT_SOLD_OUT = 'AGOTADO';
  var ADDED_DURATION = 1800;

  function init() {
    var bar = document.getElementById('mf-sticky-atc');
    var btn = document.getElementById('mf-sticky-atc-btn');
    var priceEl = document.getElementById('mf-sticky-atc-price');
    var stickyImg = document.getElementById('mf-sticky-atc-img');

    if (!bar || !btn) return;

    var purchase = document.querySelector('[data-purchase]');
    var mainAddBtn = document.querySelector('[data-btn-add]');
    var mainPriceEl = document.querySelector('[data-price-current]');
    var mainImg = document.querySelector('[data-main-image]');
    var mainQtyInput = document.querySelector('[data-qty-input]');
    var qtyMinus = document.getElementById('mf-sticky-atc-minus');
    var qtyPlus = document.getElementById('mf-sticky-atc-plus');
    var qtyVal = document.getElementById('mf-sticky-atc-qty-val');

    if (!purchase || !mainAddBtn) return;

    var addedTimer = null;

    function getQty() {
      return parseInt(qtyVal ? qtyVal.textContent : '1', 10) || 1;
    }

    function setQty(n) {
      n = Math.max(1, n);
      if (qtyVal) qtyVal.textContent = n;
      // Sync to main qty input so the proxied click uses the right quantity
      if (mainQtyInput) {
        mainQtyInput.value = n;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () { setQty(getQty() - 1); });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () { setQty(getQty() + 1); });
    }

    // Sync from main qty input changes (user edits qty on PDP)
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', function () {
        var v = parseInt(mainQtyInput.value, 10) || 1;
        if (qtyVal) qtyVal.textContent = Math.max(1, v);
      });
    }

    function isInProgress() {
      return btn.classList.contains('is-loading') || btn.classList.contains('is-added');
    }

    function syncPrice() {
      if (mainPriceEl && priceEl) {
        priceEl.textContent = mainPriceEl.textContent;
      }
    }

    // Only reflects sold-out state — never called during loading/added
    function syncState() {
      if (isInProgress()) return;
      var disabled =
        mainAddBtn.disabled ||
        mainAddBtn.getAttribute('aria-disabled') === 'true';
      // Confirm it's truly sold-out, not just transiently disabled while loading
      var isSoldOut = disabled && !mainAddBtn.classList.contains('is-loading');
      btn.disabled = isSoldOut;
      btn.textContent = isSoldOut ? TEXT_SOLD_OUT : TEXT_DEFAULT;
      syncPrice();
    }

    // MutationObserver: price changes on variant switch
    if (mainPriceEl) {
      new MutationObserver(syncPrice).observe(mainPriceEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // MutationObserver: disabled state on main button
    new MutationObserver(syncState).observe(mainAddBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });

    // MutationObserver: image src changes on variant switch
    if (mainImg && stickyImg) {
      new MutationObserver(function () {
        var src = mainImg.getAttribute('src') || mainImg.src;
        if (!src) return;
        try {
          var url = new URL(src, window.location.origin);
          url.searchParams.set('width', '80');
          stickyImg.src = url.toString();
        } catch (_) {
          stickyImg.src = src;
        }
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }

    // Cart updated → show success state then revert
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.source && e.detail.source.indexOf('cross') !== -1) return;
      clearTimeout(addedTimer);
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent = TEXT_ADDED;
      btn.disabled = false;
      addedTimer = setTimeout(function () {
        btn.classList.remove('is-added');
        setQty(1);
        syncState();
      }, ADDED_DURATION);
    });

    // Click: proxy to main ATC button
    btn.addEventListener('click', function () {
      if (btn.disabled || isInProgress()) return;
      btn.classList.add('is-loading');
      mainAddBtn.click();
      // Fallback: clear loading if cart:updated never fires
      setTimeout(function () {
        if (btn.classList.contains('is-loading')) {
          btn.classList.remove('is-loading');
          syncState();
        }
      }, 4000);
    });

    // Show/hide via IntersectionObserver on the purchase block
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          syncState();
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      },
      { threshold: 0 }
    );

    observer.observe(purchase);
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
